export const CHECKLIST_APPLICATION_CHANNEL_PREFIX = "app:checklist-application:";

// Template/builder preview has no live application, so checklistAppId resolves to null and the
// channel name lands here. The preview entrypoints render a ChannelProvider with this exact name
// so the shared checklist components' channel hooks resolve a provider (while staying unsubscribed).
export const PREVIEW_CHECKLIST_APPLICATION_CHANNEL = `${CHECKLIST_APPLICATION_CHANNEL_PREFIX}null`;

export const getChecklistApplicationChannel = (applicationId: string) =>
  `${CHECKLIST_APPLICATION_CHANNEL_PREFIX}${applicationId}`;

// Task changes are published per scope (see apps/api .../tasks/events/task-events.constants.ts).
// The Tasks page subscribes to the scope it's filtered by; the API fans out to that scope's
// ancestors so team-level viewers receive changes from anywhere in the team subtree.
export const TASK_SCOPE_CHANNEL_PREFIX = "app:scope-tasks:";
export const getTaskScopeChannel = (scopeId: string) => `${TASK_SCOPE_CHANNEL_PREFIX}${scopeId}`;

// Signal-only file changes, published to the changed file's scope and its project's scope.
// Must match apps/api .../files/events/file-events.constants.ts.
export const FILE_SCOPE_CHANNEL_PREFIX = "app:scope-files:";
export const getFileScopeChannel = (scopeId: string) => `${FILE_SCOPE_CHANNEL_PREFIX}${scopeId}`;

// Workflow (Ball-in-Court) changes. Mirrors the task-scope pattern: per-application channel for
// the drawer, per-scope channel for the dashboard / file & project tables. Strings MUST match
// apps/api .../tasks/events/workflow-events.constants.ts. Signal-only (id payloads), so clients
// refetch via REST on receipt.
export const WORKFLOW_APPLICATION_CHANNEL_PREFIX = "app:workflow-application:";
export const getWorkflowApplicationChannel = (applicationId: string) =>
  `${WORKFLOW_APPLICATION_CHANNEL_PREFIX}${applicationId}`;

export const WORKFLOW_SCOPE_CHANNEL_PREFIX = "app:scope-workflows:";
export const getWorkflowScopeChannel = (scopeId: string) => `${WORKFLOW_SCOPE_CHANNEL_PREFIX}${scopeId}`;

// Role-membership changes. Published to the one channel the grant's subtree watches: its team, or
// the organization when the grant was made there (an org grant is held inside every team). Strings
// MUST match apps/api .../principal-roles/events/role-events.constants.ts. Signal-only, so clients
// refetch via REST on receipt.
export const TEAM_ROLES_CHANNEL_PREFIX = "app:team-roles:";
export const getTeamRolesChannel = (teamScopeId: string) => `${TEAM_ROLES_CHANNEL_PREFIX}${teamScopeId}`;

export const ORG_ROLES_CHANNEL_PREFIX = "app:org-roles:";
export const getOrgRolesChannel = (organizationScopeId: string) => `${ORG_ROLES_CHANNEL_PREFIX}${organizationScopeId}`;
